import { useAtom } from '@reatom/react';
import { publicApi } from 'api';

import { declareResource, useResource } from 'libs/reatom-toolkit';

const petOwnerDescriptionResource = declareResource(
  'Pet Owner Description',
  null,
  async () => {
    const { data } = await publicApi.get(`/description-blocks/pet-owner`);
    return data;
  },
);

export function usePetOwnerDescription() {
  const { get, isLoading } = useResource(petOwnerDescriptionResource);
  return {
    isLoading,
    getPetOwnerDescription: get,
    petOwnerDescription: useAtom(petOwnerDescriptionResource),
  };
}
